import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		main: {
			// /main?safe&mock-data&utm_source=FB&country=US&area=main&exp=web_main_16_8_fasting~1
			landing: {
				experiment: () =>
					import(/* webpackChunkName: "landing" */ '@/modules/Landing/instances/experiments/web_main_16_8_fasting'),
			},
			funnel: {
				id: 'ob-universal-funnel-16-8-fasting',
				locale: ['en'],
			},
		},
	},
]

export default config
